import { render, staticRenderFns } from "./Deals.vue?vue&type=template&id=2473912b&scoped=true"
import script from "./Deals.vue?vue&type=script&lang=js"
export * from "./Deals.vue?vue&type=script&lang=js"
import style0 from "./Deals.vue?vue&type=style&index=0&id=2473912b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2473912b",
  null
  
)

export default component.exports